import { render, staticRenderFns } from "./MisOrdenes.vue?vue&type=template&id=67f7b00f&"
import script from "./MisOrdenes.vue?vue&type=script&lang=js&"
export * from "./MisOrdenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports